// extracted by mini-css-extract-plugin
export default {"gitlab-msg-body":"GitLabProjects_gitlab-msg-body__G09ho","gitlab-btn":"GitLabProjects_gitlab-btn__pUqkB","list-item":"GitLabProjects_list-item__b2Stp"};